import { Link, useMatches } from '@tanstack/react-router'
import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui/icon'

declare module '@tanstack/react-router' {
  interface StaticDataRouteOption {
    crumb?: string
  }
}

interface BreadcrumbsProps {
  current: string
  className?: string
}

// Путь собирается из матчей роутера: родительские крошки — у layout-роутов
// (staticData.crumb), лист — открытая сущность, её имя знает только страница.
export function Breadcrumbs({ current, className }: BreadcrumbsProps) {
  const matches = useMatches()
  const trail = matches.filter((match) => match.staticData.crumb != null)

  return (
    <nav aria-label="Хлебные крошки" className={cn('mb-3', className)}>
      <ol className="flex flex-wrap items-center gap-1.5 text-body-sm text-muted">
        {trail.map((match) => {
          // fullPath матча — union всех маршрутов приложения, включая index-пути
          // с хвостовым слэшем; крошка собирается на рантайме, отсюда широкий тип.
          const to: string = match.fullPath
          return (
            <li key={match.id} className="flex items-center gap-1.5">
              <Link to={to} className="transition-colors hover:text-app-fg">
                {match.staticData.crumb}
              </Link>
              <Icon name="chevron-right" size={14} className="text-faint" />
            </li>
          )
        })}
        <li aria-current="page" className="min-w-0 truncate font-medium text-app-fg">
          {current}
        </li>
      </ol>
    </nav>
  )
}
